import React from "react";

function PunjabCom() {
  return (
    <div className="row row-cols-1 row-cols-md-2 justify-content-center align-items-center">
      <div className="col">
        <h2 className="text-h-m-orange">Punjab</h2>
        <br />
        <h2 className="text-h-black">
          Privileged Majoritarianism, Disenfranchised Minorities
        </h2>
        <br />
        <p>
          In Pakistan’s second largest and most populous province, religious
          communitarian identity complicates rural and working-class experiences
          with law enforcement, criminal legal procedure, the courts and
          imprisonment, which point to a long history of the construction of
          privileged Sunni Muslim demographic majority, pushing minority groups
          to the fringes of a sense of belonging.
        </p>
      </div>
      <div className="col">
        <img
          style={{ width: "90%" }}
          src={require("../../assets/images/Punjab-map.png")}
          alt="Punjab-Map"
        />
      </div>
    </div>
  );
}

export default PunjabCom;
